import { DeferHandler } from './defer-handler.js';
import { getCookie } from 'typescript-cookie';
/**
 * A Defer Handler to allow a component to be initialized if the following
 *  conditions are met.  The defer handler looks for 2 data attributes on
 *  the component:
 *    data-defer-cookie-name: The name of the Cookie
 *    data-defer-cookie-value The value of the Cookie
 *
 *  1. If the component only has the cookie name attribute, the handler will
 *    resolve the Promise if a cookie with that name exists
 *
 *  2. If the component has both data attributes, the handler will resolve
 *    the Promise if a cookie with the name exists and it matches the value.
 *
 */
export class CookieDeferHandler extends DeferHandler {
    setHandler() {
        return new Promise((resolve) => {
            const cookieName = this.component.getAttribute('data-defer-cookie-name');
            if (this.component.hasAttribute('data-defer-cookie-value')) {
                const cookieValue = this.component.getAttribute('data-defer-cookie-value');
                if (cookieValue === getCookie(cookieName)) {
                    resolve();
                }
            }
            else {
                if (getCookie(cookieName)) {
                    resolve();
                }
            }
        });
    }
}
//# sourceMappingURL=cookie-defer-handler.js.map